export default __webpack_public_path__ + "static/Logo-f290d4b98df29fa0e9f829409f317f4b.svg";